module.exports = __webpack_public_path__ + "static/media/header-account.7493cb38.svg";